import React from 'react';
// import PropTypes from 'prop-types';
import Card from 'partial/components/Card';
import { showAlert, showDrawer } from 'partial/components/Modal';
import Button from 'partial/components/Button';
import Table from 'partial/components/Table';

function ReportsContainer() {
  const [list] = React.useState([
    {
      id: '1',
      created_at: 'Jan 01, 2022 12:00am',
      filename: 'Test Report',
      scope: 'Merchant A - Jan 1 to Jan 3 2021',
      status: 'PENDING',
    },
    {
      id: '2',
      created_at: 'Dec 01, 2022 12:00am',
      filename: 'Test Report',
      scope: 'Merchant A - Dec 1 to Dec 3 2021',
      status: 'SUCCESS',
    },
  ]);
  const renderAdd = React.useMemo(() => {
    const add = () => {
      showDrawer({
        size: 'xs',
        title: 'Add User',
        content: (onClose) => (
          <div>
            Generate Form Here <Button onClick={onClose}>Close</Button>
          </div>
        ),
      });
    };
    return (
      <div>
        <Button primary size="xs" onClick={add}>
          Generate Report
        </Button>
      </div>
    );
  }, []);
  const tableFormat = React.useMemo(() => {
    const handleDownload = (row) => () => {
      showAlert({
        title: 'Download',
        yesLabel: 'Download',
        onYes: (closeAlert) => {
          // eslint-disable-next-line
          console.log('download!', row);
          closeAlert();
        },
      });
    };
    return [
      { label: 'Date/Time', key: 'created_at', id: 'created_at' },
      { label: 'Filename', key: 'filename', id: 'filename' },
      { label: 'Scope', key: 'scope', id: 'scope' },
      { label: 'Status', key: 'status', id: 'status' },
      {
        id: 'action',
        label: <span className="sr-only">Action</span>,
        key: (row) => (
          <div className="space-x-2 transition flex items-center">
            <Button
              size="xs"
              disabled={row?.status !== 'SUCCESS'}
              onClick={handleDownload(row)}
            >
              Download
            </Button>
          </div>
        ),
        width: 100,
      },
    ];
  }, []);
  return (
    <div>
      <Card label="Reports" renderAction={renderAdd}>
        <Table data={list} format={tableFormat} />
      </Card>
    </div>
  );
}

ReportsContainer.propTypes = {};

export default ReportsContainer;
